import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";

import GetAule from "../../services/getAule";
import getLezioni from "../../services/getLezioni";
import getInsegnanti from "../../services/getInsegnanti";
import Utils from "../../utils/utils";
import ScheduleView from "../../widgets/ScheduleView";
import getMaterie from "../../services/getMaterie";

export default class DetailAula extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			startingDate: null,
			endingDate: null,
			allDatesString: [],
			allDates: [],
		};
	}

	async componentDidMount() {
		const cookies = new Cookies();

		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.aulaId = cookies.get("currentAula", { path: "/" });
		this.dateFrom = cookies.get("dateFrom", { path: "/" });
		this.dateTo = cookies.get("dateTo", { path: "/" });

		var aule = null;
		await GetAule(username, token).then(res => {
			aule = res;
		});
		this.currentAula = aule.filter(aula => aula.id == this.aulaId)[0];

		if (this.dateFrom == "") {
			this.dateFrom = "2020-01-01";
		}

		if (this.dateTo == "") {
			this.dateTo = "2025-01-01";
		}

		this.lezioni = await getLezioni(username, token);
		this.lezioni = this.lezioni.filter(lezione => lezione.id_aula == this.aulaId);
		this.insegnanti = await getInsegnanti(username, token);
		console.error(this.lezioni);

		this.dates = [];

		var date = moment(this.dateFrom, "yyyy-MM-DD");
		var finalDate = moment(this.dateTo, "yyyy-MM-DD");

		while (date <= finalDate) {
			var isAulaUsed = false;

			for (var lezione of this.lezioni) {
				if (lezione.data.substring(0, 10) == moment(date).format("yyyy-MM-DD")) {
					isAulaUsed = true;
					break;
				}
			}

			if (isAulaUsed) {
				this.dates.push(moment(date));
			}

			date = moment(date).add(1, "days");
		}

		this.setState({ isLoading: false });
	}

	render() {
		return (
			<LoadingOverlay
				active={this.state.isLoading}
				styles={{ content: base => ({ position: "relative", width: "100%", top: "200px" }) }}
				spinner
				text={"Carico..."}
			>
				{!this.state.isLoading && (
					<div>
						<PageTitle title={"Calendario " + this.currentAula.nome} />
						<div style={{ marginTop: 50 }}>
							{this.dates.map(date => {
								moment().locale("it");
								let dateString = Utils.capitalizeFirstLetter(moment(date).format("dddd LL"));
								let currentDate = moment(date).format("yyyy-MM-DD");

								return (
									<div id={"#" + date} key={Math.random()} style={{ minHeight: "155px" }}>
										{dateString}
										<ScheduleView
											key={Math.random()}
											breaks={this.breaks}
											timePrecision={15}
											date={currentDate}
											parent={this}
											lezioni={this.lezioni}
											materie={this.materie}
											type={"company"}
											subject={this.currentAula.nome}
											insegnanti={this.insegnanti}
											onMouseClick={() => console.log("Tried changing lesson")}
										/>
									</div>
								);
							})}
						</div>
					</div>
				)}
			</LoadingOverlay>
		);
	}
}
